import { CommentCountColumn } from '@/components/data-table/column-components/comments-count-column';
import { DragHandleColumn } from '@/components/data-table/column-components/drag-handle-column';
import { DimensionsColumn } from '@/components/data-table/column-components/dimensions-column';
import { ThumbnailColumn } from '@/components/data-table/column-components/thumbnail-column';
import { ProgressColumn } from '@/components/data-table/column-components/progress-column';
import { StatusesColumn } from '@/components/data-table/column-components/statuses-column';
import { FormatColumn } from '@/components/data-table/column-components/format-column';
import { ParentColumn } from '@/components/data-table/column-components/parent-column';
import { RatingColumn } from '@/components/data-table/column-components/rating-column';
import { SelectColumn } from '@/components/data-table/column-components/select-column';
import { StatusColumn } from '@/components/data-table/column-components/status-column';
import { GroupColumn } from '@/components/data-table/column-components/group-column';
import { SizeColumn } from '@/components/data-table/column-components/size-column';
import { TextColumn } from '@/components/data-table/column-components/text-column';
import { TypeColumn } from '@/components/data-table/column-components/type-column';
import { UserColumn } from '@/components/data-table/column-components/user-column';
import { ColumnType } from '@/types/column';

export const ColumnComponents: Partial<Record<ColumnType, any>> = {
  [ColumnType.CommentCount]: CommentCountColumn,
  [ColumnType.Dimensions]: DimensionsColumn,
  [ColumnType.Parent]: ParentColumn,
  [ColumnType.DragHandle]: DragHandleColumn,
  [ColumnType.Thumbnail]: ThumbnailColumn,
  [ColumnType.Progress]: ProgressColumn,
  [ColumnType.Statuses]: StatusesColumn,
  [ColumnType.Format]: FormatColumn,
  [ColumnType.Select]: SelectColumn,
  [ColumnType.Status]: StatusColumn,
  [ColumnType.Rating]: RatingColumn,
  [ColumnType.Group]: GroupColumn,
  [ColumnType.Count]: TextColumn,
  [ColumnType.Text]: TextColumn,
  [ColumnType.Size]: SizeColumn,
  [ColumnType.Type]: TypeColumn,
  [ColumnType.User]: UserColumn,
};
